export default function getactions(profileRoles, profileActions) {
  // let catalogRoles = JSON.parse(localStorage.getItem("catalogValues"))?.role;
  let catalogActions = JSON.parse(
    localStorage.getItem("catalogValues")
  )?.action;

  const rolesFromCatalogValues = JSON.parse(
    localStorage.getItem("catalogValues")
  )?.role?.inverted;

  const privilegedRoles = [
    Number(rolesFromCatalogValues?.superAdmin),
    Number(rolesFromCatalogValues?.tenantAdmin),
    Number(rolesFromCatalogValues?.admin),
  ];

  let isSuperOrTenantAdmin = privilegedRoles.some((role) => profileRoles.includes(role));

  let actionsToAccess;

  if (isSuperOrTenantAdmin) {
    delete catalogActions.inverted;
    actionsToAccess = Object.values(catalogActions);
  } else {
    actionsToAccess = profileActions.map((action, index) => {
      return catalogActions[action];
    });
  }

  return actionsToAccess;
}
